const isPositiveInt = (value) => Number.isFinite(Number(value)) && Number(value) > 0;

/** Draft agents must complete Preview at least once before Start. */
export const agentNeedsPreviewBeforeStart = (agent) => {
  if (!agent) return true;
  const status = String(agent.status || "draft").toLowerCase();
  if (status !== "draft") return false;
  return !agent.previewed_at;
};

export const validateAgentConfig = (agent) => {
  const issues = [];
  if (!agent) return { canStart: false, issues: ["Agent data is missing."] };

  if (!agent.goal || !String(agent.goal).trim()) {
    issues.push("Goal is required.");
  }

  const enabledTriggers = (agent.triggers || []).filter((item) => item && item.enabled !== false);
  if (enabledTriggers.length === 0) {
    issues.push("At least one enabled watch/trigger is required.");
  }
  if ((agent.triggers || []).length > 1) {
    issues.push("Only one trigger is supported right now.");
  }

  const actions = agent.actions || [];
  if (actions.length === 0) issues.push("At least one action is required.");
  const actionIds = new Set(actions.map((item) => item.action_id));

  const enabledRules = (agent.rules || []).filter((item) => item && item.enabled !== false);
  if (enabledRules.length === 0) issues.push("At least one enabled rule is required.");

  enabledRules.forEach((rule, index) => {
    if (!rule.if || !String(rule.if).trim()) {
      issues.push(`Rule ${index + 1} is missing an IF condition.`);
    }
    const actionRefs = rule.action_ids || [];
    if (actionRefs.length === 0) {
      issues.push(`Rule ${index + 1} must reference at least one action.`);
    }
    actionRefs.forEach((actionId) => {
      if (!actionIds.has(actionId)) {
        issues.push(`Rule ${index + 1} references unknown action ${actionId}.`);
      }
    });
  });

  const policy = agent.policy || {};
  if (!isPositiveInt(policy.max_actions_per_hour)) {
    issues.push("Policy max_actions_per_hour must be a positive number.");
  }
  if (!isPositiveInt(policy.max_notifications_per_hour)) {
    issues.push("Policy max_notifications_per_hour must be a positive number.");
  }
  if (!isPositiveInt(policy.kill_switch_error_streak)) {
    issues.push("Policy kill_switch_error_streak must be a positive number.");
  }

  return {
    canStart: issues.length === 0,
    issues,
  };
};
